import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { EventService } from 'src/app/services/event.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchModel } from 'src/app/models/search.model';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-advanced-search-home',
  templateUrl: './advanced-search-home.component.html',
  styleUrls: ['./advanced-search-home.component.css'],
})
export class AdvancedSearchHomeComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('content', { static: true }) content!: ElementRef;
  @Input() searchData!: any;
  subscription!: Subscription;
  moreChar: boolean = false;
  areaValue = 0;
  areaMaxValue = 1300;
  priceValue = 0;
  priceMaxValue = 1300000;
  searchResult: any[] = [];
  searchForm!: SearchModel;
  county: any[] = [];
  parish: any[] = [];
  selectedDistrict: any;
  selectedCounty: any;
  selectedParish: any;
  priceChange: boolean = false;
  areaChange: boolean = false;

  numberSelect: any[] = ['1', '2', '3', '4+'];

  constructor(
    private eventService: EventService,
    private modalService: NgbModal,
    private router: Router,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.subscription = this.eventService.subscribe(
      'modal-advanced-home-t1',
      () => {
        this.initForm();
        this.openModal(this.content);
      }
    );
  }

  ngAfterViewInit(): void {
    const interval = setInterval(() => {
      if (this.searchData) {
        this.areaMaxValue = this.searchData?.areaMax;
        this.priceMaxValue = this.searchData?.priceMax;
        clearInterval(interval);
      }
    }, 200);
  }

  districtChange() {
    this.selectedCounty = null;
    this.selectedParish = null;
    this.county = [];
    this.parish = [];
    if (this.selectedDistrict && this.selectedDistrict != '') {
      let selected = this.selectedDistrict.split('-');
      const country = selected[0];
      const district = selected[1];
      const region = selected[2];
      for (const [key, value] of Object.entries<any>(
        this.searchData?.locations
      )) {
        if (
          value.countryId == country &&
          value.id == district &&
          value.regionId == region
        ) {
          value.counties.forEach((county: any) => {
            this.county.push(county);
          });
        }
      }
    } else {
      this.selectedCounty = null;
      this.selectedParish = null;
    }
  }

  countyChange() {
    this.selectedParish = null;
    this.parish = [];
    this.county.forEach((c) => {
      if (c.id == this.selectedCounty) {
        c.parishs.forEach((parish: any) => {
          this.parish.push(parish);
        });
      }
    });
  }

  priceFormat(propertyPrice: any, symbol: any = '€') {
    const spaces = (price: any) =>
      String(price).replace(/(?!^)(?=(?:\d{3})+$)/g, ' ');
    return symbol + ' ' + spaces(propertyPrice);
  }

  inputChange(type: 'area' | 'price') {
    if (type === 'area') {
      this.areaChange = true;
      this.areaValue > this.areaMaxValue
        ? (this.areaMaxValue = this.areaValue)
        : null;
    } else {
      this.priceChange = true;
      this.priceValue > this.priceMaxValue
        ? (this.priceMaxValue = this.priceValue)
        : null;
    }
  }

  initForm() {
    this.searchForm = {
      businessType: null,
      propertyType: null,
      propertyCondition: null,
      bathrooms: null,
      bedrooms: null,
      characteristics: [],
      location: null,
      reference: null,
    };
  }

  prepareSearchData() {
    if (this.selectedDistrict) {
      let selected = this.selectedDistrict.split('-');
      if (this.selectedCounty) {
        if (this.selectedParish) {
          for (const [key, value] of Object.entries<any>(
            this.searchData.locations
          )) {
            if (
              value.countryId == selected[0] &&
              value.id == selected[1] &&
              value.regionId == selected[2]
            ) {
              for (const [key1, value1] of Object.entries<any>(
                value.counties
              )) {
                if (value1.id == this.selectedCounty) {
                  for (const [key2, value2] of Object.entries<any>(
                    value1.parishs
                  )) {
                    if (value2.id == this.selectedParish) {
                      this.searchForm.location = {
                        country: value.countryId,
                        region: value.regionId,
                        district: value.id,
                        county: value1.id,
                        parish: value2.id,
                      };
                    }
                  }
                }
              }
            }
          }
        } else {
          for (const [key, value] of Object.entries<any>(
            this.searchData.locations
          )) {
            if (
              value.countryId == selected[0] &&
              value.id == selected[1] &&
              value.regionId == selected[2]
            ) {
              for (const [key1, value1] of Object.entries<any>(
                value.counties
              )) {
                if (value1.id == this.selectedCounty) {
                  this.searchForm.location = {
                    country: value.countryId,
                    region: value.regionId,
                    district: value.id,
                    county: value1.id
                  };
                }
              }
            }
          }
        }
      } else {
        for (const [key, value] of Object.entries<any>(
          this.searchData.locations
        )) {
          if (
            value.countryId == selected[0] &&
            value.id == selected[1] &&
            value.regionId == selected[2]
          ) {
            this.searchForm.location = {
              country: value.countryId,
              region: value.regionId,
              district: value.id,
            };
          }
        }
      }
    }
    this.searchData.characteristics.forEach((char: any) => {
      const el: any = document.getElementById(`check-char-${char.id}`);
      el.checked ? this.searchForm.characteristics?.push(char.id) : null;
    });
  }

  searchWithNear() {
    let latlng = localStorage.getItem('latlng');
    if (latlng) {
      this.prepareSearchData();
      this.modalService.dismissAll();
      const params = {
        bedrooms:
          this.searchForm.bedrooms != '' ? this.searchForm.bedrooms : null,
        bathrooms:
          this.searchForm.bathrooms != '' ? this.searchForm.bathrooms : null,
        businessType: this.searchForm.businessType,
        propertyType: this.searchForm.propertyType,
        propertyCondition: this.searchForm.propertyCondition,
        priceMin: this.priceChange ? this.priceValue : null,
        priceMax: this.priceChange ? this.priceMaxValue : null,
        areaMin: this.areaChange ? this.areaValue : null,
        areaMax: this.areaChange ? this.areaMaxValue : null,
        characteristics:
          this.searchForm?.characteristics?.length > 0
            ? JSON.stringify(this.searchForm.characteristics)
            : null,
        location: this.searchForm?.location
          ? JSON.stringify(this.searchForm.location)
          : null,
        reference: this.searchForm?.reference
          ? this.searchForm.reference.trim()
          : null,
        latlng: true
      };
      this.router.navigate(['properties'], { queryParams: params });
    } else {
      navigator.geolocation.getCurrentPosition(position => {
        this.prepareSearchData();
        this.modalService.dismissAll();
        const params = {
          bedrooms:
            this.searchForm.bedrooms != '' ? this.searchForm.bedrooms : null,
          bathrooms:
            this.searchForm.bathrooms != '' ? this.searchForm.bathrooms : null,
          businessType: this.searchForm.businessType,
          propertyType: this.searchForm.propertyType,
          propertyCondition: this.searchForm.propertyCondition,
          priceMin: this.priceChange ? this.priceValue : null,
          priceMax: this.priceChange ? this.priceMaxValue : null,
          areaMin: this.areaChange ? this.areaValue : null,
          areaMax: this.areaChange ? this.areaMaxValue : null,
          characteristics:
            this.searchForm?.characteristics?.length > 0
              ? JSON.stringify(this.searchForm.characteristics)
              : null,
          location: this.searchForm?.location
            ? JSON.stringify(this.searchForm.location)
            : null,
          reference: this.searchForm?.reference
            ? this.searchForm.reference.trim()
            : null,
          latlng: true
        };
        this.router.navigate(['properties'], { queryParams: params });
      }, () => {
        this.errorMsg('t-location-access')
      }, { timeout: 10000 });
    }
  }

  searchWithAdvanced() {
    this.prepareSearchData();
    this.modalService.dismissAll();
    const params = {
      bedrooms:
        this.searchForm.bedrooms != '' ? this.searchForm.bedrooms : null,
      bathrooms:
        this.searchForm.bathrooms != '' ? this.searchForm.bathrooms : null,
      businessType: this.searchForm.businessType,
      propertyType: this.searchForm.propertyType,
      propertyCondition: this.searchForm.propertyCondition,
      priceMin: this.priceChange ? this.priceValue : null,
      priceMax: this.priceChange ? this.priceMaxValue : null,
      areaMin: this.areaChange ? this.areaValue : null,
      areaMax: this.areaChange ? this.areaMaxValue : null,
      characteristics:
        this.searchForm?.characteristics?.length > 0
          ? JSON.stringify(this.searchForm.characteristics)
          : null,
      location: this.searchForm?.location
        ? JSON.stringify(this.searchForm.location)
        : null,
      reference: this.searchForm?.reference
        ? this.searchForm.reference.trim()
        : null,
    };
    this.router.navigate(['properties'], { queryParams: params });
  }

  clearFilters() {
    this.areaMaxValue = this.searchData.areaMax;
    this.areaValue = 0;
    this.priceMaxValue = this.searchData.priceMax;
    this.priceValue = 0;
    this.searchForm.businessType = null;
    this.searchForm.propertyCondition = null;
    this.searchForm.propertyType = null;
    this.selectedParish = null;
    this.parish = [];
    this.selectedCounty = null;
    this.county = [];
    this.selectedDistrict = null;
  }

  /**
   * open modal
   * @param entityUpdate
   * @param content
   */
  openModal(content: any) {
    this.modalService.open(content, {
      size: 'xl',
      centered: true,
      keyboard: false,
      scrollable: true,
    });
  }

  /**
 * Title sweet alert
 * @param Error Msg modal content
 */
  errorMsg(errorMsg: string) {
    const msg = this.translateService.instant(errorMsg);
    Swal.fire({
      title: '',
      text: msg,
      icon: 'warning',
      confirmButtonColor: 'rgb(54, 69, 116)',
      confirmButtonText: 'Close'
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
